import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import type { TrayScaleNoticeProps } from "./types";

export const TrayScaleNotice = ({ notice }: TrayScaleNoticeProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-start gap-2 rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-800">
      <AlertTriangle size={14} className="mt-0.5 shrink-0 text-amber-600" />
      <span>
        {notice.kind === "missingScale"
          ? t("smartSurveyor.planComparison.quantities.scaleMissing")
          : t("smartSurveyor.planComparison.quantities.scaleDiffers", {
              percent: notice.differencePercent,
            })}
      </span>
    </div>
  );
};
